import { AuthCallbackController } from './auth-callback-controller';
import { BookmarkletController } from './bookmarklet-controller';
import { EntityTermsAndConditionsController } from './entity-terms-and-conditions-controller';
import { DeeplinkBuilderController } from './deeplink-builder-controller';
import { ErrorCallbackController } from './error-callback-controller';
import { HomeController } from './home-controller';
import { PrivacyPolicyController } from './privacy-policy-controller';
import { ProductsController } from './products-controller';
import { ProgramsController } from './programs-controller';
import { PzSignUpController } from './pz-sign-up-controller';
import { PzSignupConfirmationController } from './pz-signup-confirmation-controller';
import { QuicklinksController } from 'controllers/quicklinks-controller';
import { SignInController } from './sign-in-controller';
import { SignoutController } from './signout-controller';
import { SignUpController } from './signup-controller';
import { TermsOfUseController } from './terms-of-use.controller';
import { VrboSearchController } from 'controllers/vrbo-search-controller';
import { ZendeskLoginController } from './zendesk/login-controller';
import { ZendeskLogoutController } from 'controllers/zendesk/logout-controller';
import { ZendeskSsoController } from 'controllers/zendesk/sso-controller';

export const controllers = [
  AuthCallbackController,
  BookmarkletController,
  EntityTermsAndConditionsController,
  DeeplinkBuilderController,
  HomeController,
  PrivacyPolicyController,
  ProductsController,
  ProgramsController,
  PzSignUpController,
  PzSignupConfirmationController,
  QuicklinksController,
  SignInController,
  SignoutController,
  SignUpController,
  TermsOfUseController,
  VrboSearchController,
  ZendeskLoginController,
  ZendeskLogoutController,
  ZendeskSsoController,
  // 404 error needs to come last as its a catch all route
  ErrorCallbackController,
];
